export const validEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const getStatusName = status => {
    return {
        AC: 'Accepted',
        RE: 'Rejected',
        WA: 'Waiting list',
        BA: 'Backup',
        HO: 'Host',
        PE: 'Pending'
    }[status]
}
